import { render, staticRenderFns } from "./clientLis-old.vue?vue&type=template&id=b9f709e0"
import script from "./clientLis-old.vue?vue&type=script&lang=js"
export * from "./clientLis-old.vue?vue&type=script&lang=js"
import style0 from "./clientLis-old.vue?vue&type=style&index=0&id=b9f709e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports